import { useState, useEffect } from "react";
import { Button, Modal } from "@/config/antd";
import AttendeeCard from "@/pages/event_management/single_campaign/components/attendees_tabs/Attendee_Card";
import "@/assets/styles/attendees_modal.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMultipleUsersAsync,
  selectMultipleUsers,
  selectIsLoadingMultiple,
} from "@/store/redux/slices/user/user_slice";
import { selectCurrentEvent } from "@/store/redux/slices/event/event_slice";

const AttendeesTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const currentEvent = useSelector(selectCurrentEvent);
  const users = useSelector(selectMultipleUsers);
  const isLoading = useSelector(selectIsLoadingMultiple);

  // Feature flag to toggle attendee data fetching
  const enableAttendeesFetch = false; // Set to true when endpoint is fixed

  useEffect(() => {
    if (enableAttendeesFetch && currentEvent?.members?.length > 0) {
      dispatch(fetchMultipleUsersAsync(currentEvent.members));
    }
  }, [dispatch, currentEvent?.members, enableAttendeesFetch]);

  const attendees = users.map((user) => ({
    id: user._id,
    name: user.fullname,
    avatar: user.profileImage || null,
    confirmed: true,
    username: user.username,
  }));

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="w-full">
      {isLoading ? (
        <div className="text-center py-4">Loading attendees...</div>
      ) : !enableAttendeesFetch || attendees.length === 0 ? (
        <div className="text-center text-gray py-4">
          No attendees for this event yet.
        </div>
      ) : (
        <>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-darkGrey">
              Attendees ({attendees.length})
            </h3>
            <Button
              type="link"
              className="text-primary font-bold"
              onClick={showModal}>
              VIEW ALL
            </Button>
          </div>

          <div className="space-y-4">
            {attendees.map((attendee) => (
              <AttendeeCard key={attendee.id} attendee={attendee} />
            ))}
          </div>

          <Modal
            title="Attendees"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            width={600}
            className="attendees-modal">
            <div className="space-y-4 max-h-[60vh] overflow-y-auto">
              {attendees.map((attendee) => (
                <AttendeeCard
                  onClose={handleCancel}
                  key={attendee.id}
                  attendee={attendee}
                />
              ))}
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default AttendeesTab;
